import React from "react";
import { ThemeProvider } from "styled-components";
import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  primary: "#49525D",
  tabBackgroundColor: "#F6F6F7",
  contentTextColor: "#1D1E1E",
  buttonBackground: "linear-gradient(#6f6f6f, #484848)",
  buttonText: "#FFF",
};

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;
